module.exports = __webpack_public_path__ + "d252b0da56252c58c060b6ec12b18359.svg";